import * as Yup from 'yup'

export const validationSchema = (maxRewards: number) =>
  Yup.object({
    internalName: Yup.string().required('Required'),
    displayName: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
    displayOrder: Yup.number()
      .min(1, `Display order must be between 1 and ${maxRewards}`)
      .required('Required')
      .max(maxRewards, `Display order must be between 1 and ${maxRewards}`),
    startDate: Yup.string().required('Required'),
    endDate: Yup.string().required('Required'),
    companies: Yup.array()
      .of(Yup.number().required())
      .required('Companies is required')
      .min(1, 'Select at least one company'),
    countries: Yup.array()
      .of(Yup.string().required())
      .min(1, 'Select at least one country')
      .required('Countries is required'),
    rewardStatusId: Yup.number()
      .min(1, 'Program status is required')
      .required('Program status is required'),
    resetCadenceId: Yup.number()
      .min(1, 'Reset Cadence is required')
      .required('Reset Cadence is required'),

    tiers: Yup.array().of(
      Yup.object({
        name: Yup.string().required('Tier name is required'),
        trackingMetricId: Yup.number().test(
          'is-valid-metric',
          'Tracking Metric is required',
          (value) => typeof value === 'number' && value > 0
        ),
        rewardProgramTierConditionLogicId: Yup.number().test(
          'is-valid-metric',
          'Conditional logic is required',
          (value) => typeof value === 'number' && value > 0
        ),
        thresholdValue: Yup.number().required('Threshold value is required'),
        rewardId: Yup.string().min(1, 'Reward is required').required('Reward is required'),
        callToActionText: Yup.string().required('Call to Action is required'),
        metrics: Yup.array().of(
          Yup.object({
            trackingMetricId: Yup.number().test(
              'is-valid-metric',
              'Tracking Metric is required',
              (value) => typeof value === 'number' && value > 0
            ),
            rewardProgramTierConditionLogicId: Yup.number().test(
              'is-valid-metric',
              'Conditional logic is required',
              (value) => typeof value === 'number' && value > 0
            ),
            value: Yup.number().required('Threshold value is required'),
          })
        ),
      })
    ),
  })
